import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";

import { auth } from "../apis/firebase";

import { rootReducer } from "./rootReducer";

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export async function setupAxios(axios) {
  axios.interceptors.request.use(
    async (config) => {
      if (auth && auth.currentUser) {
        const currentToken = await auth.currentUser.getIdToken();
        if (currentToken) {
          config.headers.Authorization = `Bearer ${currentToken}`;
        }
      }

      return config;
    },
    (err) => {
      console.log("rejected");
      return Promise.reject(err);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      if (!!response && !!response?.data?.data) {
        response.data = response.data.data;
      }
      return response;
    },
    (error) => {
      if (!!error.response && error.response.status === 401) {
        // handleLogout();
      }
      return error;
    }
  );
}
